import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  title?: string;
  input: string;
  error?: string;
  forgot_pin?: boolean;

  onInputNumber(number: number): void;
  onClose?(): void;
  onRemoveNumber(): void;
  onPressForgot?(): void;
}

const LockScreenView: FC<Props> = (props) => {
  const { title, input, error, forgot_pin, onInputNumber, onClose, onRemoveNumber, onPressForgot } =
    props;

  const input_length = input.length;
  const show_delete = input_length > 0;

  return (
    <Container>
      <Row justifyContent="center">
        <Row flex={1}></Row>

        <Row flex={1} justifyContent="flex-end">
          {onClose ? (
            <CloseButton size="large" icon="times" onPress={onClose} />
          ) : (
            <Spacer height="32px" />
          )}
        </Row>
      </Row>

      <Row justifyContent="center">
        <FontAwesomeIcon icon="lock" color="white" />
      </Row>

      <Spacer height="16px" />

      <Text
        variant="h3"
        weight="semibold"
        style={{ color: error ? palette.Red : 'white' }}
      >
        {title || ''}
      </Text>

      <Spacer height="32px" />

      <Row justifyContent="space-evenly" width={300}>
        <InputCircle active={input_length > 0} />
        <InputCircle active={input_length > 1} />
        <InputCircle active={input_length > 2} />
        <InputCircle active={input_length > 3} />
      </Row>

      <Spacer height="32px" />

      <NumberButtonsContainer>
        {number_rows.map((row, idx) => (
          <NumberButtonRow key={idx}>
            {row.map((num) => (
              <NumberButton key={num} number={num} onPress={onInputNumber} />
            ))}
          </NumberButtonRow>
        ))}

        <Row justifyContent="center">
          {/* A spacer of the same width as button */}
          <Spacer flex={1} />

          <NumberButton number={0} onPress={onInputNumber} />

          <Row flex={1} justifyContent="flex-end">
            {show_delete ? (
              <NewButton
                variant="text"
                textStyle={{ color: 'white' }}
                onPress={onRemoveNumber}
              >
                Delete
              </NewButton>
            ) : null}
          </Row>
        </Row>

        {onPressForgot && !forgot_pin ? (
          <Row justifyContent="center">
            <Spacer height="8px" />
            <NewButton
              variant="text"
              textStyle={{ color: 'white' }}
              onPress={onPressForgot}
            >
              Forgot my PIN
            </NewButton>
          </Row>
        ) : null}
      </NumberButtonsContainer>
    </Container>
  );
};

const NumberButton = ({
  number,
  onPress,
}: {
  number: number;
  onPress: (number: number) => void;
}) => {
  const handlePress = () => onPress(number);

  return (
    <NumberButtonCircle onPress={handlePress}>
      <WhiteText variant="h3" weight="semibold" color="white">
        {number}
      </WhiteText>
    </NumberButtonCircle>
  );
};

const Container = styled.View`
  padding-top: 16px;
  align-items: center;
`;

const NumberButtonsContainer = styled.View`
  width: 312px;
`;

const InputCircle = styled.View<{ active?: boolean }>`
  height: 24px;
  width: 24px;
  border: 2px solid #ffffff;
  border-radius: 12px;
  ${({ active }) => (active ? 'background-color: white;' : '')}
`;

const NumberButtonCircle = styled.TouchableOpacity`
  width: 84px;
  height: 84px;

  align-items: center;
  justify-content: center;

  background-color: rgba(5, 22, 51, 0.15);
  border-radius: 100px;
`;

const NumberButtonRow = styled.View`
  flex-direction: row;
  justify-content: space-between;

  margin-bottom: 30px;
`;

const WhiteText = styled(Text)`
  color: white;
`;

const CloseButton = styled(NewButton)`
  background-color: rgba(5, 22, 51, 0.15);
`;

const number_rows = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
];

export default LockScreenView;
